import Vue from 'vue'
import App from './App.vue'
import _ from 'lodash'
import store from './store'
import router from './router'
import { mapGetters } from 'vuex'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCarousel from 'vue-carousel'
import moment from 'moment'
import vSelect from 'vue-select'
import './assets/scss/main.scss'
import VueCookie from 'vue-cookie'
import BootstrapVue from 'bootstrap-vue'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import Autolinker from 'autolinker'
import { intercepterConfig } from './api/instance'
import * as Sentry from '@sentry/browser'
import { captureConsoleIntegration, httpClientIntegration } from '@sentry/integrations'

var VueEventBus = require('vue-event-bus')

const ACTIVE_ROUTER_EXPIRY = ['NpsPage', 'PhotoPay', 'MonetaryCompensationService', 'MonetaryCompensation', 'CashPickUp']

function initializeSentry() {
  console.log('Initialize Sentry')
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENVIRONMENT,
    ignoreErrors: ['Network Error', 'originalPrompt'],
    integrations: [
      captureConsoleIntegration({
        levels: ['error']
      }),
      httpClientIntegration({
        ailedRequestStatusCodes: [[500, 599]],
        failedRequestTargets: [/.*/]
      })
    ],
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

// initializeSentry()

Vue.use(datePicker)
Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.prototype.$publicPath = process.env.BASE_URL
Vue.prototype.Autolinker = Autolinker
Vue.use(VueSweetalert2)
Vue.use(VueCarousel)
Vue.use(VueCookie)
Vue.use(BootstrapVue)
Vue.use(VueEventBus)
Vue.use(intercepterConfig)
import SmoothPicker from 'vue-smooth-picker'
import 'vue-smooth-picker/dist/css/style.css'
Vue.use(SmoothPicker)

Vue.mixin({
  computed: {
    ...mapGetters({
      airline: 'airline',
      lang: 'lang',
      pax: 'pax',
      title: 'title',
      internalCmtId: 'interCmtId',
      PaxsGroup: 'paxsGroup',
      isConfirmYet: 'isConfirmYet',
      isInfoFlightPage: 'isInfoFlightPage',
      direction: 'direction'
    })
  },
  watch: {
    pax: function () {
      this.checkRouter()
    },
    airline: function () {
      this.checkRouter()
    },
    PaxsGroup: function () {
      this.checkRouter()
    },
    '$store.state.lang': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !_.isEmpty(newValue)) {
          this.setTemplateDirection()
        }
      },
      immediate: true // trigger the handler immediately upon component initialization
    }
  },
  created: function () {
    let secret = this.$route.query.secret
    if (this.$route.path == '/info-flight-update') {
      return
    }
    if (!_.isEmpty(this.airline) && !this.airline.is_active) {
      this.$router.push({ path: '/page-error', query: { secret: secret } })
      return
    }

    this.checkRouter()
  },
  mounted() {
    this.$store.dispatch('getAirlineShareDetail')
    this.$store.dispatch('getAirline')
    if (_.isEmpty(this.pax)) {
      this.$store.dispatch('getPax')
    }
    this.$store.dispatch('getTitle')
    if (_.isEmpty(this.$store.state.paxsGroup)) {
      this.$store.dispatch('getPaxsGroup')
    }
    this.addFaviconToHeader()
    this.setTemplateDirection()
  },
  methods: {
    checkExpired() {
      let secret = this.$route.query.secret
      let currentPage = this.$route.name

      if (this.pax.is_expired) {
        if (this.pax.is_expired_p2c && this.pax.is_expired_mc) {
          if (
            this.pax.nps_option == 0 &&
            !_.includes(['Home', 'Privacy', 'Disclaimer', 'Impressum', 'PaxContactConfirm'], currentPage)
          ) {
            // Show expired message
            this.$router.push({ path: '/home', query: { secret: secret } })
          } else if (
            this.pax.nps_option == 1 &&
            !_.includes(['NpsPage', 'Privacy', 'Disclaimer', 'Impressum', 'PaxContactConfirm'], currentPage)
          ) {
            // Redirect to nps page
            this.$router.push({ path: '/nps-page', query: { secret: secret } })
          }
        } else {
          if (!_.includes(ACTIVE_ROUTER_EXPIRY, currentPage)) {
            if (!_.includes(['ExpireLink'], currentPage)) {
              this.$router.push({ path: '/expire-link', query: { secret: secret } })
            }
          }
        }

        return true
      }

      return false
    },
    // Check confirm or not and force confirm first to do others except in Passenger Invite List page
    checkRouter() {
      let secret = this.$route.query.secret
      if (_.isEmpty(this.airline) || _.isEmpty(this.pax) || _.isEmpty(this.PaxsGroup)) {
        return
      }
      // Airline deactive redirect 404
      if (!this.airline.is_active) {
        this.$router.push({ path: '/page-error', query: { secret: secret } })
        return
      }

      if (this.$route.path == '/info-flight-update') {
        return
      }
      if (this.$cookie.get('confirm' + this.pax.curPaxID)) {
        this.$store.commit('CONFIRM_UPDATE', true)
      }

      // If not confirm pax this is me already
      // Separate conditions to check redirect.
      // Because there will be cases where the link will expire and pax this is me has not been selected.
      // This will result in a redirect loop between PaxContactConfirm and ExpireLink
      if (!this.isConfirmYet && this.PaxsGroup.length > 1) {
        if (this.$route.name != 'PaxContactConfirm') {
          this.$router.push({ path: '/pax-contact-confirm', query: { secret: secret } })
        }
        return
      }

      this.checkExpired()
    },
    addFaviconToHeader() {
      const existingFavicon = document.getElementById('favicon')
      const templateConfig = this?.airline?.template_config || null
      const favicon = templateConfig ? templateConfig?.mb_favicon || process.env?.BASE_URL + 'favicon.ico' : null

      if (!existingFavicon && favicon) {
        const link = document.createElement('link')
        link.rel = 'icon'
        link.id = 'favicon'
        link.type = 'image/x-icon'
        link.href = favicon

        const head = document.head || document.getElementsByTagName('head')[0]
        head.appendChild(link)
      }
    },
    setTemplateDirection() {
      this.$store.commit('TEMPLATE_INIT')
      // Set direction
      document.body.dir = this.direction
      // Set style with variables base on direction
      const rootElement = document.querySelector(':root')
      const cssVariables = {
        '--photo2claim-icon-margin': this.direction == 'rtl' ? '5px 0px 5px 15px' : '5px 15px 5px 0px',
        '--text-align': this.direction == 'rtl' ? 'right' : '',
        '--voucher-icon-border-radius': this.direction == 'rtl' ? '0 0.75rem 0.75rem 0' : '0.75rem 0 0 0.75rem',
        '--meal-plan-box-border-radius': this.direction == 'rtl' ? '0.75rem 0 0.75rem 0' : '0 0.75rem 0 0.75rem',
        '--text-this-is-me-right': this.direction == 'rtl' ? '67px' : '-78px',
        '--voucher-ear-marker-border-radius': this.direction == 'rtl' ? '0.75rem 0 0 0.75rem' : '0 0.75rem 0.75rem 0',
        '--modal-header-close-margin': this.direction == 'rtl' ? '-1rem auto -1rem -1rem' : '-1rem -1rem -1rem auto',
        '--radio-checkbox-margin-left': this.direction == 'rtl' ? '0.5rem' : '0',
        '--transform-flight-icon': this.direction == 'rtl' ? 'scaleX(-1)' : 'none'
      }
      const entries = Object.entries(cssVariables)
      for (const [key, value] of entries) {
        rootElement.style.setProperty(key, value)
      }
    }
  }
})

Vue.component('VSelect', vSelect)
Vue.component('VStyle', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

new Vue({
  store,
  router,
  watch: {
    $route(to) {
      let comment = 'View: [createDateTime] ' + to.path + '/'
      this.$store.dispatch('insertInterCmt', { secret: this.$route.query.secret, comment: comment })
    }
  },
  render: (h) => h(App)
}).$mount('#app')
